import React from 'react';
import { Box, Checkbox, FormControlLabel, TextField, Typography } from '@material-ui/core';
import SectionCard from './SectionCard';

const DEFAULT_DESCRIPTION = 'Validate instance availability before deployment.';

export default function CapacityReservationsSection({ form, setField, fillHeight, showAutoExpire = true, description }) {
    return (
        <SectionCard icon="how_to_reg" title="Capacity Reservations" fillHeight={fillHeight}>
            <FormControlLabel
                control={
                    <Checkbox
                        checked={form.enableCapacityReservation ?? false}
                        onChange={(e) => setField('enableCapacityReservation', e.target.checked)}
                        name="enableCapacityReservation"
                        color="primary"
                    />
                }
                label={
                    <Box>
                        <Typography variant="body1" style={{ fontWeight: 500 }}>
                            Reserve Capacity Before Deploy
                        </Typography>
                        <Typography variant="caption" color="textSecondary" style={{ display: 'block', marginTop: '4px' }}>
                            {description || DEFAULT_DESCRIPTION}
                        </Typography>
                    </Box>
                }
            />

            {showAutoExpire && form.enableCapacityReservation && (
                <Box mt={2} ml={4} p={2} style={{ backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={form.capacityReservationAutoExpire ?? true}
                                onChange={(e) => setField('capacityReservationAutoExpire', e.target.checked)}
                                name="capacityReservationAutoExpire"
                                color="primary"
                            />
                        }
                        label={
                            <Box>
                                <Typography variant="body2" style={{ fontWeight: 500 }}>
                                    Auto-Expire (Safety Net)
                                </Typography>
                                <Typography variant="caption" color="textSecondary" style={{ display: 'block', marginTop: '4px' }}>
                                    Prevent orphaned capacity charges if deployment fails.
                                </Typography>
                            </Box>
                        }
                    />

                    {(form.capacityReservationAutoExpire ?? true) && (
                        <Box mt={1} ml={4}>
                            <TextField
                                type="number"
                                label="Expiration Hours"
                                variant="outlined"
                                size="small"
                                value={form.capacityReservationExpireHours ?? 1}
                                onChange={(e) => setField('capacityReservationExpireHours', parseInt(e.target.value, 10) || 1)}
                                inputProps={{ min: 1, max: 24 }}
                                style={{ width: '200px' }}
                                helperText="Hours (1-24)"
                            />
                        </Box>
                    )}
                </Box>
            )}
        </SectionCard>
    );
}
